const {h, render, Component} = require('preact');
const queryString = require('qs')
const OrderContainer = require('./order')
const OrdersView = require('../../views/main/orders')
const NoItemsView = require('../../views/common/no_items')
const SupportAPIHelper = require('../../../../../support/frontend/helpers/API')
const ErrorView = require('../main/error')

class Orders extends Component {
  constructor() {
    super();
    this.createOrdersTable = this.createOrdersTable.bind(this);
    this.setState({isLoadingInProgress: true, noOrdersFound: false})
  }

  componentWillMount() {
    let queryParams = {
      page: 0,
      sort_attribute: 'purchased_at',
      sort_order: 'descending'
    }
    let qs = queryString.stringify(queryParams)
    let url = `${Groupon.Utils.getConfigFromDom().SUPPORTBASEURL}/user/orders`;
    let ordersUrl = url + "?" + qs
    let errorCb = (response) => {
      this.setState({orders: null, isLoadingInProgress: false, 'isFailure': true});
    }
    let successCb = (response) => {
      if (response && response.orders && response.orders.length === 0){
        this.setState({noOrdersFound: true});
      }
      else if (response && response.orders.length > 0) {
        this.setState({orders: response.orders, length: response.orders.length, groupons: response.pagination.count, isLoadingInProgress: false});
      }
    }
    this.setState({isLoadingInProgress: true})
    SupportAPIHelper.get(ordersUrl, null, successCb, errorCb, false);
  }

  createOrdersTable() {
    let table = [], rows = 2, columns = 2, currentIndex;
    if (this.state.orders) {
      for (let row = 0; row < rows; row++) {
        let children = []
        for (let col = 0; col < columns; col++) {
          currentIndex = columns * row + col
          if (currentIndex < this.state.orders.length) {
            children.push(<OrderContainer item={this.state.orders[currentIndex]}/>)
          }
        }
        if(children.length==1)
          children.push(<OrderContainer/>)
        table.push(<tr class="orderTableRow">{children}</tr>)
      }
    }
    return table;
  }

  render() {
    if (this.state.noOrdersFound){
      return <NoItemsView noOrdersFound = {this.state.noOrdersFound} />;
    }
    else if (this.state.isFailure){
      return (<ErrorView/>)
    }
    else{
      return (
        <OrdersView
          page='landing'
          ordersTable={this.createOrdersTable.bind(this)}
          length={this.state.length}
          groupons={this.state.groupons}
          isLoadingInProgress={this.state.isLoadingInProgress}
        />
      );
    }

  }
}

module.exports = Orders
